/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type ResponseActivityGroup from '@linc-technologies/linced-common/enums/response-activity-group';
import { resolved } from '@linc-technologies/linced-common/utils/arrays';
import type Media from 'linced-app/models/media';
import type Person from 'linced-app/models/person';
import type School from 'linced-app/models/school';

// Proto: attendance.ResponseActivity.
export default class ResponseActivity extends Model {
  declare [Type]: 'attendance/response-activity';

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @alias('school.id')
  declare school_id: string | null | undefined;

  @belongsTo('person', { async: true, inverse: null })
  declare personId: AsyncBelongsTo<Person>;

  @alias('personId')
  declare person: AsyncBelongsTo<Person>;

  @alias('person.id')
  declare person_id: string | null | undefined;

  @belongsTo('person', { async: true, inverse: null })
  declare recordedById: AsyncBelongsTo<Person>;

  @alias('recordedById')
  declare recordedBy: AsyncBelongsTo<Person>;

  @alias('recordedBy.id')
  declare recordedBy_id: string | null | undefined;

  @belongsTo('person', { async: true, inverse: null })
  declare completedById: AsyncBelongsTo<Person>;

  @alias('completedById')
  declare completedBy: AsyncBelongsTo<Person>;

  @alias('completedBy.id')
  declare completedBy_id: string | null | undefined;

  @attr('string')
  declare completedDate: string | undefined;

  @attr('number', { defaultValue: 0 })
  declare responseActivity: EnumValue<typeof ResponseActivityGroup> | 0;

  @attr('string', { defaultValue: '' })
  declare detail: string;

  @attr('string', { defaultValue: '' })
  declare notes: string;

  @attr('boolean', { defaultValue: false })
  declare hideNotes: boolean;

  // Media
  @hasMany('media', { async: true, inverse: null })
  declare mediaIds: AsyncHasMany<Media>;

  @alias('mediaIds')
  declare media: AsyncHasMany<Media>;

  @computed('media.content.[]')
  get media_ids() {
    return resolved(this.media).map((record) => record.id);
  }

  @attr('number', { defaultValue: 0 })
  declare threshold: number;
}
